// import React, { useState, useEffect } from "react";
// import { Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, FormControl, InputLabel, Select, CircularProgress, IconButton, List, ListItem, Typography } from "@material-ui/core";
// import CloseIcon from "@material-ui/icons/Close";
// import axios from "axios";
// import { BACKEND_BASE_URL } from "../config";

// const AddMappingForm = ({ open, onClose, onMappingAdded }) => {
//     const [formData, setFormData] = useState({ state: "", county: "", municipality_name: "", municipalities: [] });
//     const [newMunicipality, setNewMunicipality] = useState({ state: "", county: "", municipality: "", channel_type: "Board of Education", channel_urls: [] });
//     const [stateOptions, setStateOptions] = useState([]);
//     const [countyOptions, setCountyOptions] = useState([]);
//     const [municipalityOptions, setMunicipalityOptions] = useState([]);
//     const [associatedCountyOptions, setAssociatedCountyOptions] = useState([]);
//     const [associatedMunicipalityOptions, setAssociatedMunicipalityOptions] = useState([]);
//     const [channelOptions, setChannelOptions] = useState([]);
//     const [loading, setLoading] = useState({
//         states: false, counties: false, municipalities: false, associatedCounties: false,
//         associatedMunicipalities: false, saving: false
//     });

//     useEffect(() => {
//         if (open) fetchStates();
//     }, [open]);

//     useEffect(() => {
//         if (formData.state) fetchCounties();
//         else setCountyOptions([]);
//     }, [formData.state]);

//     useEffect(() => {
//         if (formData.state && formData.county) fetchMunicipalities();
//         else setMunicipalityOptions([]);
//     }, [formData.state, formData.county]);

//     useEffect(() => {
//         if (formData.state && formData.county && formData.municipality_name) fetchChannels();
//         else setChannelOptions([]);
//     }, [formData.state, formData.county, formData.municipality_name]);

//     useEffect(() => {
//         if (newMunicipality.state) fetchAssociatedCounties();
//         else setAssociatedCountyOptions([]);
//     }, [newMunicipality.state]);

//     useEffect(() => {
//         if (newMunicipality.state && newMunicipality.county) fetchAssociatedMunicipalities();
//         else setAssociatedMunicipalityOptions([]);
//     }, [newMunicipality.state, newMunicipality.county]);

//     const fetchAssociatedCounties = async () => {
//         setLoading((prev) => ({ ...prev, associatedCounties: true }));
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/counties/`, { params: { state: newMunicipality.state } });
//             setAssociatedCountyOptions(data?.counties || []);
//         } catch (error) {
//             console.error("Error fetching counties:", error);
//         }
//         setLoading((prev) => ({ ...prev, associatedCounties: false }));
//     };

//     const fetchAssociatedMunicipalities = async () => {
//         setLoading((prev) => ({ ...prev, associatedMunicipalities: true }));
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipalities/filter/`, { params: { state: newMunicipality.state, county: newMunicipality.county } });
//             setAssociatedMunicipalityOptions(data?.municipalities || []);
//         } catch (error) {
//             console.error("Error fetching municipalities:", error);
//         }
//         setLoading((prev) => ({ ...prev, associatedMunicipalities: false }));
//     };



//     const fetchStates = async () => {
//         setLoading((prev) => ({ ...prev, states: true }));
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/states/`);
//             setStateOptions(data?.states || []);
//         } catch (error) {
//             console.error("Error fetching states:", error);
//         }
//         setLoading((prev) => ({ ...prev, states: false }));
//     };

//     const fetchCounties = async () => {
//         setLoading((prev) => ({ ...prev, counties: true }));
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/counties/`, { params: { state: formData.state } });
//             setCountyOptions(data?.counties || []);
//         } catch (error) {
//             console.error("Error fetching counties:", error);
//         }
//         setLoading((prev) => ({ ...prev, counties: false }));
//     };

//     const fetchMunicipalities = async () => {
//         setLoading((prev) => ({ ...prev, municipalities: true }));
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipalities/filter/`, { params: { state: formData.state, county: formData.county } });
//             setMunicipalityOptions(data?.municipalities || []);
//         } catch (error) {
//             console.error("Error fetching municipalities:", error);
//         }
//         setLoading((prev) => ({ ...prev, municipalities: false }));
//     };

//     const fetchChannels = async () => {
//         setLoading((prev) => ({ ...prev, channels: true }));
//         try {
//             const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipality/channel-urls/`, {
//                 params: { state: formData.state, county: formData.county, municipality: formData.municipality_name },
//             });
//             setChannelOptions(data?.channel_urls || []);
//         } catch (error) {
//             console.error("Error fetching channels:", error);
//         }
//         setLoading((prev) => ({ ...prev, channels: false }));
//     };

//     const handleChange = (event) => {
//         setFormData({ ...formData, [event.target.name]: event.target.value });
//     };

//     const handleMunicipalityChange = (event) => {
//         setNewMunicipality({ ...newMunicipality, [event.target.name]: event.target.value });
//     };

//     const handleChannelSelect = (event) => {
//         setNewMunicipality({ ...newMunicipality, channel_urls: event.target.value });
//     };

//     const handleMunicipalityAdd = () => {
//         if (newMunicipality.municipality.trim() && newMunicipality.channel_urls.length > 0) {
//             setFormData((prev) => ({
//                 ...prev,
//                 municipalities: [...prev.municipalities, newMunicipality],
//             }));
//             setNewMunicipality({ state: "", county: "", municipality: "", channel_type: "Board of Education", channel_urls: [] });
//         }
//     };

//     const handleMunicipalityDelete = (index) => {
//         setFormData((prev) => ({
//             ...prev,
//             municipalities: prev.municipalities.filter((_, i) => i !== index),
//         }));
//     };

//     const handleSave = async () => {
//         setLoading((prev) => ({ ...prev, saving: true }));
//         try {
//             await axios.post(`${BACKEND_BASE_URL}/api/mapping-towns/`, {
//                 state: formData.state,
//                 county: formData.county,
//                 big_town: formData.municipality_name,
//                 small_towns: formData.municipalities,
//             });
//             onClose();
//             onMappingAdded();  // Call fetchMappingData after saving
//         } catch (error) {
//             console.error("Error saving mapping:", error);
//         }
//         setLoading((prev) => ({ ...prev, saving: false }));
//     };

//     return (

//         <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//             <DialogTitle>Add New Mapping</DialogTitle>
//             <DialogContent style={{ maxHeight: "70vh", overflowY: "auto", padding: "20px" }}>
//                 <FormControl fullWidth margin="dense" variant="outlined">
//                     <InputLabel>State</InputLabel>
//                     <Select name="state" value={formData.state} onChange={handleChange} fullWidth>
//                         {loading.states ? (
//                             <MenuItem disabled>
//                                 <CircularProgress size={24} /> Loading...
//                             </MenuItem>
//                         ) : (
//                             stateOptions.map((state) => (
//                                 <MenuItem key={state} value={state}>{state}</MenuItem>
//                             ))
//                         )}
//                     </Select>
//                 </FormControl>

//                 <FormControl fullWidth margin="dense" variant="outlined" disabled={!formData.state}>
//                     <InputLabel>County</InputLabel>
//                     <Select name="county" value={formData.county} onChange={handleChange} fullWidth>
//                         {loading.counties ? (
//                             <MenuItem disabled>
//                                 <CircularProgress size={24} /> Loading...
//                             </MenuItem>
//                         ) : (
//                             countyOptions.map((county) => (
//                                 <MenuItem key={county} value={county}>{county}</MenuItem>
//                             ))
//                         )}
//                     </Select>
//                 </FormControl>

//                 <FormControl fullWidth margin="dense" variant="outlined" disabled={!formData.state || !formData.county}>
//                     <InputLabel>Town</InputLabel>
//                     <Select name="municipality_name" value={formData.municipality_name} onChange={handleChange} fullWidth>
//                         {loading.municipalities ? (
//                             <MenuItem disabled>
//                                 <CircularProgress size={24} /> Loading...
//                             </MenuItem>
//                         ) : municipalityOptions.length === 0 ? (
//                             <MenuItem disabled>No Town available</MenuItem>
//                         ) : (
//                             municipalityOptions.map((municipality) => (
//                                 <MenuItem key={municipality} value={municipality}>{municipality}</MenuItem>
//                             ))
//                         )}
//                     </Select>
//                 </FormControl>

//                 <Typography variant="subtitle1" style={{ marginTop: 15 }}>Associated Towns</Typography>
//                 <Grid container spacing={2} alignItems="center" style={{ marginTop: 5 }}>
//                     <Grid item xs={2}>
//                         {/* <TextField fullWidth label="State" name="state" value={newMunicipality.state} onChange={handleMunicipalityChange} margin="dense" variant="outlined" /> */}
//                         <FormControl fullWidth margin="dense" variant="outlined">
//                             <InputLabel>State</InputLabel>
//                             <Select name="state" value={newMunicipality.state} onChange={handleMunicipalityChange} fullWidth>
//                                 {loading.states ? (
//                                     <MenuItem disabled>
//                                         <CircularProgress size={24} /> Loading...
//                                     </MenuItem>
//                                 ) : (
//                                     stateOptions.map((state) => (
//                                         <MenuItem key={state} value={state}>{state}</MenuItem>
//                                     ))
//                                 )}
//                             </Select>
//                         </FormControl>

//                     </Grid>
//                     <Grid item xs={2}>
//                         {/* <TextField fullWidth label="County" name="county" value={newMunicipality.county} onChange={handleMunicipalityChange} margin="dense" variant="outlined" /> */}
//                         <FormControl fullWidth margin="dense" variant="outlined" disabled={!newMunicipality.state}>
//                             <InputLabel>County</InputLabel>
//                             <Select name="county" value={newMunicipality.county} onChange={handleMunicipalityChange} fullWidth>
//                                 {loading.associatedCounties ? (
//                                     <MenuItem disabled>
//                                         <CircularProgress size={24} /> Loading...
//                                     </MenuItem>
//                                 ) : (
//                                     associatedCountyOptions.map((county) => (
//                                         <MenuItem key={county} value={county}>{county}</MenuItem>
//                                     ))
//                                 )}
//                             </Select>
//                         </FormControl>
//                     </Grid>
//                     <Grid item xs={3}>
//                         {/* <TextField fullWidth label="Municipality" name="municipality" value={newMunicipality.municipality} onChange={handleMunicipalityChange} margin="dense" variant="outlined" /> */}
//                         <FormControl fullWidth margin="dense" variant="outlined" disabled={!newMunicipality.state || !newMunicipality.county}>
//                             <InputLabel>Town</InputLabel>
//                             {/* <Select name="municipality" value={newMunicipality.municipality} onChange={handleMunicipalityChange} fullWidth>
//                                 {loading.associatedMunicipalities ? (
//                                     <MenuItem disabled>
//                                         <CircularProgress size={24} /> Loading...
//                                     </MenuItem>
//                                 ) : associatedMunicipalityOptions.length === 0 ? (
//                                     <MenuItem disabled>No Town available</MenuItem>
//                                 ) : (
//                                     associatedMunicipalityOptions.map((municipality) => (
//                                         <MenuItem key={municipality} value={municipality}>{municipality}</MenuItem>
//                                     ))
//                                 )}
//                             </Select> */}
//                             <Select name="municipality" value={newMunicipality.municipality} onChange={handleMunicipalityChange} fullWidth>
//                                 {loading.associatedMunicipalities ? (
//                                     <MenuItem disabled>
//                                         <CircularProgress size={24} /> Loading...
//                                     </MenuItem>
//                                 ) : associatedMunicipalityOptions.length === 0 ? (
//                                     <MenuItem disabled>No Town available</MenuItem>
//                                 ) : (
//                                     associatedMunicipalityOptions
//                                         .filter(municipality => municipality !== formData.municipality_name) // Exclude selected municipality
//                                         .map((municipality) => (
//                                             <MenuItem key={municipality} value={municipality}>{municipality}</MenuItem>
//                                         ))
//                                 )}
//                             </Select>

//                         </FormControl>
//                     </Grid>
//                     <Grid item xs={4}>
//                         <FormControl fullWidth margin="dense" variant="outlined">
//                             <InputLabel>Channel URLs</InputLabel>
//                             <Select multiple value={newMunicipality.channel_urls} onChange={handleChannelSelect} fullWidth>
//                                 {channelOptions.length > 0 ? (
//                                     channelOptions.map((url) => (
//                                         <MenuItem key={url} value={url}>{url}</MenuItem>
//                                     ))
//                                 ) : (
//                                     <MenuItem disabled>No BOE Channel associated</MenuItem>
//                                 )}
//                             </Select>
//                         </FormControl>
//                     </Grid>

//                     <Grid item xs={1} style={{ display: "flex", justifyContent: "center" }}>
//                         <Button variant="contained" color="primary" onClick={handleMunicipalityAdd} style={{ height: "100%", minWidth: "50px" }}>Add</Button>
//                     </Grid>
//                 </Grid>

//                 {formData.municipalities.map((mun, index) => (
//                     <Grid container spacing={2} key={index} alignItems="center" style={{ padding: "10px 0", borderBottom: "1px solid #ddd" }}>
//                         <Grid item xs={2}><Typography>{mun.state}</Typography></Grid>
//                         <Grid item xs={2}><Typography>{mun.county}</Typography></Grid>
//                         <Grid item xs={3}><Typography>{mun.municipality}</Typography></Grid>
//                         <Grid item xs={4} style={{ wordBreak: "break-word" }}>
//                             <List dense>
//                                 {mun.channel_urls.map((url, i) => (
//                                     <ListItem key={i} style={{ paddingLeft: 0, display: "list-item", listStyleType: "disc" }}>
//                                         <Typography noWrap style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "100%" }}><a href={`${url}`} style={{ textDecoration: "none", color: "#007bff" }}>{url}</a></Typography>
//                                     </ListItem>
//                                 ))}
//                             </List>
//                         </Grid>
//                         <Grid item xs={1} style={{ display: "flex", justifyContent: "center" }}>
//                             <IconButton onClick={() => handleMunicipalityDelete(index)}>
//                                 <CloseIcon />
//                             </IconButton>
//                         </Grid>
//                     </Grid>
//                 ))}
//             </DialogContent>

//             <DialogActions style={{ padding: "20px" }}>
//                 <Button onClick={onClose} color="secondary">Cancel</Button>
//                 <Button variant="contained" color="primary" onClick={handleSave} disabled={loading.saving}>
//                     {loading.saving ? <CircularProgress size={24} /> : "Save"}
//                 </Button>
//             </DialogActions>
//         </Dialog>

//     );
// };

// export default AddMappingForm;



import { useState, useEffect } from "react";
import { Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, FormControl, InputLabel, Select, CircularProgress, IconButton, List, ListItem, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import { BACKEND_BASE_URL } from "../config";

const AddMappingForm = ({ open, onClose, onMappingAdded }) => {
    const [formData, setFormData] = useState({ 
        country: "", 
        state: "", 
        county: "", 
        municipality_name: "", 
        municipalities: [] 
    });
    const [newMunicipality, setNewMunicipality] = useState({ 
        country: "", 
        state: "", 
        county: "", 
        municipality: "", 
        channel_type: "Board of Education", 
        channel_urls: [] 
    });
    
    // Main form options
    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [countyOptions, setCountyOptions] = useState([]);
    const [municipalityOptions, setMunicipalityOptions] = useState([]);
    
    // Associated municipalities options (separate state)
    const [associatedStateOptions, setAssociatedStateOptions] = useState([]);
    const [associatedCountyOptions, setAssociatedCountyOptions] = useState([]);
    const [associatedMunicipalityOptions, setAssociatedMunicipalityOptions] = useState([]);
    const [channelOptions, setChannelOptions] = useState([]);
    
    const [loading, setLoading] = useState({
        countries: false,
        states: false, 
        counties: false, 
        municipalities: false, 
        associatedStates: false,
        associatedCounties: false,
        associatedMunicipalities: false, 
        channels: false,
        saving: false
    });

    useEffect(() => {
        if (open) {
            fetchCountries();
            // Reset form when dialog opens
            setFormData({ 
                country: "", 
                state: "", 
                county: "", 
                municipality_name: "", 
                municipalities: [] 
            });
            setNewMunicipality({ 
                country: "", 
                state: "", 
                county: "", 
                municipality: "", 
                channel_type: "Board of Education", 
                channel_urls: [] 
            });
        }
    }, [open]);

    // MAIN FORM useEffect hooks - only affect main form state
    useEffect(() => {
        if (formData.country) {
            fetchStates();
        } else {
            setStateOptions([]);
            setFormData(prev => ({ ...prev, state: "", county: "", municipality_name: "" }));
        }
    }, [formData.country]);

    useEffect(() => {
        if (formData.state) {
            fetchCounties();
        } else {
            setCountyOptions([]);
            setFormData(prev => ({ ...prev, county: "", municipality_name: "" }));
        }
    }, [formData.state]);

    useEffect(() => {
        if (formData.state && formData.county) {
            fetchMunicipalities();
        } else {
            setMunicipalityOptions([]);
            setFormData(prev => ({ ...prev, municipality_name: "" }));
        }
    }, [formData.state, formData.county]);

    useEffect(() => {
        if (formData.state && formData.county && formData.municipality_name) {
            fetchChannels();
        } else {
            setChannelOptions([]);
        }
    }, [formData.state, formData.county, formData.municipality_name]);

    // ASSOCIATED MUNICIPALITIES useEffect hooks - only affect associated municipalities state
    useEffect(() => {
        if (newMunicipality.country) {
            fetchAssociatedStates();
        } else {
            setAssociatedStateOptions([]);
            setAssociatedCountyOptions([]);
            setAssociatedMunicipalityOptions([]);
            setNewMunicipality(prev => ({ ...prev, state: "", county: "", municipality: "" }));
        }
    }, [newMunicipality.country]);

    useEffect(() => {
        if (newMunicipality.state) {
            fetchAssociatedCounties();
        } else {
            setAssociatedCountyOptions([]);
            setAssociatedMunicipalityOptions([]);
            setNewMunicipality(prev => ({ ...prev, county: "", municipality: "" }));
        }
    }, [newMunicipality.state]);

    useEffect(() => {
        if (newMunicipality.state && newMunicipality.county) {
            fetchAssociatedMunicipalities();
        } else {
            setAssociatedMunicipalityOptions([]);
            setNewMunicipality(prev => ({ ...prev, municipality: "" }));
        }
    }, [newMunicipality.state, newMunicipality.county]);

    const fetchCountries = async () => {
        setLoading((prev) => ({ ...prev, countries: true }));
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/countries/`);
            setCountryOptions(data || []);
        } catch (error) {
            console.error("Error fetching countries:", error);
        }
        setLoading((prev) => ({ ...prev, countries: false }));
    };

    // MAIN FORM fetch functions
    const fetchStates = async () => {
        if (!formData.country) return;
        setLoading((prev) => ({ ...prev, states: true }));
        try {
            const response = await axios.get(`${BACKEND_BASE_URL}/api/states/`, {
                params: { country_id: formData.country }
            });
            if (response.data && response.data.states) {
                setStateOptions(response.data.states);
            }
        } catch (error) {
            console.error("Error fetching states:", error);
            setStateOptions([]);
        }
        setLoading((prev) => ({ ...prev, states: false }));
    };

    const fetchCounties = async () => {
        if (!formData.state) return;
        setLoading((prev) => ({ ...prev, counties: true }));
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/counties/`, { 
                params: { state: formData.state } 
            });
            setCountyOptions(data?.counties || []);
        } catch (error) {
            console.error("Error fetching counties:", error);
            setCountyOptions([]);
        }
        setLoading((prev) => ({ ...prev, counties: false }));
    };

    const fetchMunicipalities = async () => {
        if (!formData.state || !formData.county) return;
        setLoading((prev) => ({ ...prev, municipalities: true }));
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipalities/filter/`, { 
                params: { state: formData.state, county: formData.county } 
            });
            setMunicipalityOptions(data?.municipalities || []);
        } catch (error) {
            console.error("Error fetching municipalities:", error);
            setMunicipalityOptions([]);
        }
        setLoading((prev) => ({ ...prev, municipalities: false }));
    };

    const fetchChannels = async () => {
        if (!formData.state || !formData.county || !formData.municipality_name) return;
        setLoading((prev) => ({ ...prev, channels: true }));
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipality/channel-urls/`, {
                params: { 
                    state: formData.state, 
                    county: formData.county, 
                    municipality: formData.municipality_name 
                },
            });
            setChannelOptions(data?.channel_urls || []);
        } catch (error) {
            console.error("Error fetching channels:", error);
            setChannelOptions([]);
        }
        setLoading((prev) => ({ ...prev, channels: false }));
    };

    // ASSOCIATED MUNICIPALITIES fetch functions
    const fetchAssociatedStates = async () => {
        if (!newMunicipality.country) return;
        setLoading((prev) => ({ ...prev, associatedStates: true }));
        try {
            const response = await axios.get(`${BACKEND_BASE_URL}/api/states/`, {
                params: { country_id: newMunicipality.country }
            });
            if (response.data && response.data.states) {
                setAssociatedStateOptions(response.data.states);
            }
        } catch (error) {
            console.error("Error fetching associated states:", error);
            setAssociatedStateOptions([]);
        }
        setLoading((prev) => ({ ...prev, associatedStates: false }));
    };

    const fetchAssociatedCounties = async () => {
        if (!newMunicipality.state) return;
        setLoading((prev) => ({ ...prev, associatedCounties: true }));
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/counties/`, { 
                params: { state: newMunicipality.state } 
            });
            setAssociatedCountyOptions(data?.counties || []);
        } catch (error) {
            console.error("Error fetching counties:", error);
            setAssociatedCountyOptions([]);
        }
        setLoading((prev) => ({ ...prev, associatedCounties: false }));
    };

    const fetchAssociatedMunicipalities = async () => {
        if (!newMunicipality.state || !newMunicipality.county) return;
        setLoading((prev) => ({ ...prev, associatedMunicipalities: true }));
        try {
            const { data } = await axios.get(`${BACKEND_BASE_URL}/api/municipalities/filter/`, { 
                params: { state: newMunicipality.state, county: newMunicipality.county } 
            });
            setAssociatedMunicipalityOptions(data?.municipalities || []);
        } catch (error) {
            console.error("Error fetching municipalities:", error);
            setAssociatedMunicipalityOptions([]);
        }
        setLoading((prev) => ({ ...prev, associatedMunicipalities: false }));
    };

    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value });
    };

    const handleMunicipalityChange = (event) => {
        setNewMunicipality({ ...newMunicipality, [event.target.name]: event.target.value });
    };

    const handleChannelSelect = (event) => {
        setNewMunicipality({ ...newMunicipality, channel_urls: event.target.value });
    };

    // Helper function to get country name by ID
    const getCountryName = (countryId) => {
        const country = countryOptions.find(c => c.id === countryId);
        return country ? country.name : countryId;
    };

    const handleMunicipalityAdd = () => {
        // Validate required fields
        if (!newMunicipality.municipality.trim()) {
            alert("Please select a municipality");
            return;
        }
        
        if (!newMunicipality.channel_urls || newMunicipality.channel_urls.length === 0) {
            alert("Please select at least one channel URL");
            return;
        }

        // Create the municipality object with proper structure
        const municipalityToAdd = {
            country: getCountryName(newMunicipality.country),
            state: newMunicipality.state,
            county: newMunicipality.county,
            municipality: newMunicipality.municipality,
            channel_type: newMunicipality.channel_type,
            channel_urls: newMunicipality.channel_urls
        };

        console.log("Adding municipality:", municipalityToAdd);

        setFormData((prev) => ({
            ...prev,
            municipalities: [...prev.municipalities, municipalityToAdd],
        }));

        // Reset the associated municipality form only
        setNewMunicipality({ 
            country: "", 
            state: "", 
            county: "", 
            municipality: "", 
            channel_type: "Board of Education", 
            channel_urls: [] 
        });
        
        // Clear associated municipality options
        setAssociatedStateOptions([]);
        setAssociatedCountyOptions([]);
        setAssociatedMunicipalityOptions([]);
    };

    const handleMunicipalityDelete = (index) => {
        setFormData((prev) => ({
            ...prev,
            municipalities: prev.municipalities.filter((_, i) => i !== index),
        }));
    };

    const handleSave = async () => {
        // Validate main form
        if (!formData.country || !formData.state || !formData.county || !formData.municipality_name) {
            alert("Please fill in all required fields for the main municipality");
            return;
        }

        if (formData.municipalities.length === 0) {
            alert("Please add at least one associated municipality");
            return;
        }

        setLoading((prev) => ({ ...prev, saving: true }));
        
        const payload = {
            country: getCountryName(formData.country),
            state: formData.state,
            county: formData.county,
            big_town: formData.municipality_name,
            small_towns: formData.municipalities,
        };

        console.log("Payload being sent:", payload);
        
        try {
            const response = await axios.post(`${BACKEND_BASE_URL}/api/mapping-towns/`, payload);
            console.log("Save response:", response.data);
            onClose();
            onMappingAdded();
        } catch (error) {
            console.error("Error saving mapping:", error);
            alert("Error saving mapping. Please check console for details.");
        }
        setLoading((prev) => ({ ...prev, saving: false }));
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle>Add New Mapping</DialogTitle>
            <DialogContent style={{ maxHeight: "70vh", overflowY: "auto", padding: "20px" }}>
                {/* Main form country selection */}
                <FormControl fullWidth margin="dense" variant="outlined">
                    <InputLabel>Country</InputLabel>
                    <Select name="country" value={formData.country} onChange={handleChange} fullWidth>
                        {loading.countries ? (
                            <MenuItem disabled>
                                <CircularProgress size={24} /> Loading...
                            </MenuItem>
                        ) : (
                            countryOptions.map((country) => (
                                <MenuItem key={country.id} value={country.id}>{country.name}</MenuItem>
                            ))
                        )}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="dense" variant="outlined" disabled={!formData.country}>
                    <InputLabel>State</InputLabel>
                    <Select name="state" value={formData.state} onChange={handleChange} fullWidth>
                        {loading.states ? (
                            <MenuItem disabled>
                                <CircularProgress size={24} /> Loading...
                            </MenuItem>
                        ) : stateOptions.length === 0 ? (
                            <MenuItem disabled>No States available</MenuItem>
                        ) : (
                            stateOptions.map((state) => (
                                <MenuItem key={state} value={state}>{state}</MenuItem>
                            ))
                        )}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="dense" variant="outlined" disabled={!formData.state}>
                    <InputLabel>County</InputLabel>
                    <Select name="county" value={formData.county} onChange={handleChange} fullWidth>
                        {loading.counties ? (
                            <MenuItem disabled>
                                <CircularProgress size={24} /> Loading...
                            </MenuItem>
                        ) : (
                            countyOptions.map((county) => (
                                <MenuItem key={county} value={county}>{county}</MenuItem>
                            ))
                        )}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="dense" variant="outlined" disabled={!formData.state || !formData.county}>
                    <InputLabel>Town</InputLabel>
                    <Select name="municipality_name" value={formData.municipality_name} onChange={handleChange} fullWidth>
                        {loading.municipalities ? (
                            <MenuItem disabled>
                                <CircularProgress size={24} /> Loading...
                            </MenuItem>
                        ) : municipalityOptions.length === 0 ? (
                            <MenuItem disabled>No Town available</MenuItem>
                        ) : (
                            municipalityOptions.map((municipality) => (
                                <MenuItem key={municipality} value={municipality}>{municipality}</MenuItem>
                            ))
                        )}
                    </Select>
                </FormControl>

                <Typography variant="subtitle1" style={{ marginTop: 15 }}>Associated Towns</Typography>
                <Grid container spacing={2} alignItems="center" style={{ marginTop: 5 }}>
                    {/* Country field for associated municipalities */}
                    <Grid item xs={2}>
                        <FormControl fullWidth margin="dense" variant="outlined">
                            <InputLabel>Country</InputLabel>
                            <Select name="country" value={newMunicipality.country} onChange={handleMunicipalityChange} fullWidth>
                                {loading.countries ? (
                                    <MenuItem disabled>
                                        <CircularProgress size={24} /> Loading...
                                    </MenuItem>
                                ) : (
                                    countryOptions.map((country) => (
                                        <MenuItem key={country.id} value={country.id}>{country.name}</MenuItem>
                                    ))
                                )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={2}>
                        <FormControl fullWidth margin="dense" variant="outlined" disabled={!newMunicipality.country}>
                            <InputLabel>State</InputLabel>
                            <Select name="state" value={newMunicipality.state} onChange={handleMunicipalityChange} fullWidth>
                                {loading.associatedStates ? (
                                    <MenuItem disabled>
                                        <CircularProgress size={24} /> Loading...
                                    </MenuItem>
                                ) : associatedStateOptions.length === 0 ? (
                                    <MenuItem disabled>No States available</MenuItem>
                                ) : (
                                    associatedStateOptions.map((state) => (
                                        <MenuItem key={state} value={state}>{state}</MenuItem>
                                    ))
                                )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={2}>
                        <FormControl fullWidth margin="dense" variant="outlined" disabled={!newMunicipality.state}>
                            <InputLabel>County</InputLabel>
                            <Select name="county" value={newMunicipality.county} onChange={handleMunicipalityChange} fullWidth>
                                {loading.associatedCounties ? (
                                    <MenuItem disabled>
                                        <CircularProgress size={24} /> Loading...
                                    </MenuItem>
                                ) : (
                                    associatedCountyOptions.map((county) => (
                                        <MenuItem key={county} value={county}>{county}</MenuItem>
                                    ))
                                )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={2}>
                        <FormControl fullWidth margin="dense" variant="outlined" disabled={!newMunicipality.state || !newMunicipality.county}>
                            <InputLabel>Town</InputLabel>
                            <Select name="municipality" value={newMunicipality.municipality} onChange={handleMunicipalityChange} fullWidth>
                                {loading.associatedMunicipalities ? (
                                    <MenuItem disabled>
                                        <CircularProgress size={24} /> Loading...
                                    </MenuItem>
                                ) : associatedMunicipalityOptions.length === 0 ? (
                                    <MenuItem disabled>No Town available</MenuItem>
                                ) : (
                                    associatedMunicipalityOptions
                                        .filter(municipality => municipality !== formData.municipality_name)
                                        .map((municipality) => (
                                            <MenuItem key={municipality} value={municipality}>{municipality}</MenuItem>
                                        ))
                                )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth margin="dense" variant="outlined">
                            <InputLabel>Channel URLs</InputLabel>
                            <Select multiple value={newMunicipality.channel_urls} onChange={handleChannelSelect} fullWidth>
                                {channelOptions.length > 0 ? (
                                    channelOptions.map((url) => (
                                        <MenuItem key={url} value={url}>{url}</MenuItem>
                                    ))
                                ) : (
                                    <MenuItem disabled>No BOE Channel associated</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={1} style={{ display: "flex", justifyContent: "center" }}>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={handleMunicipalityAdd} 
                            style={{ height: "100%", minWidth: "50px" }}
                            disabled={!newMunicipality.municipality || !newMunicipality.channel_urls.length}
                        >
                            Add
                        </Button>
                    </Grid>
                </Grid>

                {/* Display added municipalities */}
                {formData.municipalities.length > 0 && (
                    <div style={{ marginTop: 20 }}>
                        <Typography variant="subtitle2" style={{ marginBottom: 10 }}>
                            Added Municipalities ({formData.municipalities.length}):
                        </Typography>
                        {formData.municipalities.map((mun, index) => (
                            <Grid container spacing={2} key={index} alignItems="center" style={{ padding: "10px 0", borderBottom: "1px solid #ddd" }}>
                                <Grid item xs={2}><Typography>{mun.country}</Typography></Grid>
                                <Grid item xs={2}><Typography>{mun.state}</Typography></Grid>
                                <Grid item xs={2}><Typography>{mun.county}</Typography></Grid>
                                <Grid item xs={2}><Typography>{mun.municipality}</Typography></Grid>
                                <Grid item xs={3} style={{ wordBreak: "break-word" }}>
                                    <List dense>
                                        {mun.channel_urls.map((url, i) => (
                                            <ListItem key={i} style={{ paddingLeft: 0, display: "list-item", listStyleType: "disc" }}>
                                                <Typography noWrap style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "100%" }}>
                                                    <a href={url} style={{ textDecoration: "none", color: "#007bff" }} target="_blank" rel="noopener noreferrer">
                                                        {url}
                                                    </a>
                                                </Typography>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                                <Grid item xs={1} style={{ display: "flex", justifyContent: "center" }}>
                                    <IconButton onClick={() => handleMunicipalityDelete(index)} color="secondary">
                                        <CloseIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        ))}
                    </div>
                )}
            </DialogContent>

            <DialogActions style={{ padding: "20px" }}>
                <Button onClick={onClose} color="secondary">Cancel</Button>
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={handleSave} 
                    disabled={loading.saving || formData.municipalities.length === 0}
                >
                    {loading.saving ? <CircularProgress size={24} /> : `Save (${formData.municipalities.length} municipalities)`}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddMappingForm;